/**
 * Custom hook para verificar la sesión del usuario.
 * Utiliza la expiracion del token almacenado en localStorage para determinar si la sesión es válida.
 * Si la sesión no es válida, redirige al usuario a la página de inicio de sesión.
 * @param {string} token - El token de autenticación del usuario.
 * @returns {boolean} - Retorna true si la sesión es válida, false en caso contrario.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogoutUser } from "../redux/actions/actions";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";


export const useSessionChecker = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const checkTokenExpiration = () => {
            const token = localStorage.getItem('token');
            if (token) {
                const decodedToken = jwtDecode(token);
                const currentTime = Date.now() / 1000;
                if (decodedToken.exp < currentTime) {
                    localStorage.removeItem('token');
                    dispatch(LogoutUser());
                    console.log("Token expirado, redirigiendo a inicio de sesión");
                    navigate('/login');
                }
            } else {
                console.log("No hay token, redirigiendo a inicio de sesión");
                dispatch(LogoutUser());
                navigate('/login');
            }
        }
        checkTokenExpiration();
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkTokenExpiration();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    }, [dispatch, navigate])
}

export default useSessionChecker;
